module.exports = __webpack_public_path__ + "img/0100.00aecf97.png";